'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('../constants');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    queries: {},
    data: {},
    errors: {}
  };
  var action = arguments[1];
  switch (action.type) {
    /**
     * Change the query of the current searchable list
     */
    case _constants.actionTypes.SEARCHABLE_LIST_CHANGE_QUERY:
      return Object.assign({}, state, {
        queries: Object.assign({}, state.queries, _defineProperty({}, action.meta.name, action.query))
      });
    /**
     * Handle rejected state
     */
    case _constants.actionTypes.SEARCHABLE_LIST_FETCH + '_' + _reduxPromiseMiddleware.REJECTED:
      return Object.assign({}, state, {
        errors: Object.assign({}, state.errors, _defineProperty({}, action.meta.name, action))
      });
    /**
     * Handle a successful response
     */
    case _constants.actionTypes.SEARCHABLE_LIST_FETCH + '_' + _reduxPromiseMiddleware.FULFILLED:
      return Object.assign({}, state, {
        data: Object.assign({}, state.data, _defineProperty({}, action.meta.name, action.payload)),
        errors: Object.assign({}, state.errors, _defineProperty({}, action.meta.name, undefined))
      });
    /**
     * Clear the searchable lists query and data
     */
    case _constants.actionTypes.SEARCHABLE_LIST_CLEAR:
      return Object.assign({}, state, {
        queries: Object.assign({}, state.queries, _defineProperty({}, action.meta.name, undefined)),
        data: Object.assign({}, state.data, _defineProperty({}, action.meta.name, undefined)),
        errors: Object.assign({}, state.errors, _defineProperty({}, action.meta.name, undefined))
      });
    default:
      return state;
  }
};